// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__qoMiM","buttons":"SendReceipts_buttons__GVoJY","email":"SendReceipts_email__30CfJ","bookApptTitle":"SendReceipts_bookApptTitle__2E1Yl"};